import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import AuthProtected from "./authProtected"

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route : any, idx : any) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => {
                        const LayoutComponent = route.layout === "blank" ? NonAuthLayout : VerticalLayout;

                        return (
                            <Route
                                path={route.path}
                                element={
                                    <AuthProtected>
                                        <LayoutComponent>{route.component}</LayoutComponent>
                                    </AuthProtected>}
                                key={idx}
                            />
                        );
                    })}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;
